/* eslint-disable import/prefer-default-export */
export const priceFormatter = (number, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  if (number % 1 === 0) return number
  return number.toLocaleString('de-DE', { minimumFractionDigits, maximumFractionDigits })
}
